<template>
  <div>
    <el-row type="flex" class="tables">
      <el-col :span="index > 8 ? 24: 8" v-for="(item,index) in listData" :key="index">
        <el-col :span="index > 8 ? 3: 9">{{item.name}}</el-col>
        <el-col :span="index > 8 ? 21: 15">
          {{item.value}}
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { strategyInfos } from '@/api/productControl'
export default {
  data () {
    return {
      row: null,
      listData: []
    }
  },
  created () {
    this.row = JSON.parse(this.$route.query.row)
    this.getStrategyInfos()
  },
  methods: {
    getStrategyInfos () {
      const params = {
        params: {
          firmwareId: this.row.firmwareId,
          strategyId: this.row.strategyId
        }
      }
      strategyInfos(params).then(res => {
        const resData = res.data.data
        if (resData.sourceVersions && resData.sourceVersions.length !== 0) {
          // resData.sourceVersions +=
          let sourceVersions = ''
          resData.sourceVersions.forEach(element => {
            sourceVersions += element + '  '
          })
          resData.sourceVersions = sourceVersions
        }
        this.listData = [
          { name: '批次ID', value: resData.strategyId },
          { name: '所属产品', value: resData.productName },
          { name: '固件版本号', value: resData.destVersion },
          { name: '待升级版本号', value: resData.sourceVersions },
          { name: '升级策略', value: resData.strategyType === 1 ? '全量升级' : '灰度升级' },
          { name: '升级范围', value: resData.upgradeScope === 1 ? '定向升级' : '全部设备' },
          { name: '升级时间', value: resData.updateTime },
          { name: '批次类型', value: resData.batchType === 1 ? '批量升级' : '验证固件' },
          { name: '批次状态', value: resData.batchStatus === 1 ? '待升级' : resData.batchStatus === 2 ? '升级中' : resData.batchStatus === 3 ? '已完成' : resData.batchStatus === 4 ? '已取消' : '' },
          { name: '设备间隔超时时间', value: resData.upgradeTimeout }
        ]
      })
    }
  }
}
</script>

<style lang='less' scoped>
.tables{
    flex-wrap: wrap;
    border-bottom: 1px solid  #ecedee;
    border-right: 1px solid  #ecedee;
    margin-bottom: 20px;
    .el-col-8, .el-col-24{
      border-top: 1px solid  #ecedee;
       .el-col-9,.el-col-3{
        border-right: 1px solid  #ecedee;
        border-left: 1px solid  #ecedee;
        background-color: #fbfbfc;
        color: #73777a;
        padding: 14px 12px;
      }
      .el-col-15,.el-col-21{
        color: #373d41;
        padding: 14px 12px;
      }
    }
  }
</style>
